import React, { Component } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../graphql/mutations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus, faLayerGroup } from '@fortawesome/free-solid-svg-icons'
import { ProgressBar, unitsDoneOf } from './progress';
import './pomodoro.css'

class Pomodoro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTask: this.props.row,
      totalCurrentPomodoro: 0,
      totalEstimatedPomodoro: 0
    };
  }

  componentDidMount = async() => {
    const child_tasks = this.props.subTasks
    var currentTask = this.props.row;
    if (this.totalEstimatedPomodoro(child_tasks)>0) {
      currentTask.pomodoros = this.totalCurrentPomodoro(child_tasks).toString()
      currentTask.estimatedPomodoro = this.totalEstimatedPomodoro(child_tasks).toString()
      let {tableData, owner, ...graphqlUpdatedTask} = currentTask;
      await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
    }
    this.setState({currentTask: this.props.row, totalCurrentPomodoro: this.totalCurrentPomodoro(child_tasks), totalEstimatedPomodoro: this.totalEstimatedPomodoro(child_tasks)})
    if (this.props.onTotalsChange) this.props.onTotalsChange()
  }

  totalCurrentPomodoro = (child_tasks) => {
    const reducer = (accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue);
    var tempPomodoros = this.props.row.pomodoros;
    var tempArrayPomodoros = child_tasks.data.listTasks.items.map(unitsDoneOf)
    if (tempArrayPomodoros.length > 0) {
      tempPomodoros = (parseInt(tempArrayPomodoros.reduce(reducer)))
    }
    return tempPomodoros;
  }

  totalEstimatedPomodoro = (child_tasks) => {
    const reducer = (accumulator, currentValue) => parseInt(accumulator) + parseInt(currentValue);
    var tempPomodoros = this.props.row.estimatedPomodoro;
    var tempArrayPomodoros = child_tasks.data.listTasks.items.map(x => x.estimatedPomodoro)
    if (tempArrayPomodoros.length > 0) {
      tempPomodoros = (parseInt(tempArrayPomodoros.reduce(reducer)))
    }
    return tempPomodoros;
  }

  componentDidUpdate = async() => {
    // Always write to the current row: after a refetch, state.currentTask can
    // point at a stale copy, and the parent would then re-sum stale numbers.
    var updatedTask = this.props.row;
    const child_tasks = this.props.subTasks
    const hasChildren = child_tasks.data && child_tasks.data.listTasks.items.length > 0;
    // A parent's totals must equal the sum of its subtasks; correct any drift
    // left behind by incremental updates elsewhere.
    const rowDrifted = hasChildren && (
      String(updatedTask.pomodoros) !== String(this.totalCurrentPomodoro(child_tasks)) ||
      String(updatedTask.estimatedPomodoro) !== String(this.totalEstimatedPomodoro(child_tasks))
    );
    if (rowDrifted || this.state.totalCurrentPomodoro !== this.totalCurrentPomodoro(child_tasks) || this.state.totalEstimatedPomodoro !== this.totalEstimatedPomodoro(child_tasks)) {
      updatedTask.pomodoros = this.totalCurrentPomodoro(child_tasks).toString()
      updatedTask.estimatedPomodoro = this.totalEstimatedPomodoro(child_tasks).toString()
      let {tableData, owner, ...graphqlUpdatedTask} = updatedTask;
      await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
      this.setState({currentTask: this.props.row, totalCurrentPomodoro: this.totalCurrentPomodoro(child_tasks), totalEstimatedPomodoro: this.totalEstimatedPomodoro(child_tasks)})
      if (this.props.onTotalsChange) this.props.onTotalsChange()
    }
  }

  stepper = (label, value, onMinus, onPlus) => {
    return (
      <div className="stepper">
        <span className="stepper__label">{label}</span>
        <div className="stepper__control">
          {this.props.allowEdit && (
            <button className="stepper__btn" onClick={onMinus} aria-label={'Decrease ' + label.toLowerCase()}>
              <FontAwesomeIcon icon={faMinus} />
            </button>
          )}
          <span className="stepper__value">{value}</span>
          {this.props.allowEdit && (
            <button className="stepper__btn" onClick={onPlus} aria-label={'Increase ' + label.toLowerCase()}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          )}
        </div>
      </div>
    )
  }

  render () {
    const rowData = this.props.row
    const hasSubTasks = this.props.subTasks.data && this.props.subTasks.data.listTasks.items.length > 0;

    if (hasSubTasks) {
      return (
        <div className="units-card">
          <span className="eyebrow">Units</span>
          <div className="units-card__total">
            {this.totalCurrentPomodoro(this.props.subTasks)}
            <span>/{this.totalEstimatedPomodoro(this.props.subTasks)}</span>
          </div>
          <ProgressBar task={rowData} size="sm" />
          <p className="units-card__hint">
            <FontAwesomeIcon icon={faLayerGroup} /> Rolled up from subtasks
          </p>
        </div>
      )
    }

    return (
      <div className="units-card">
        <span className="eyebrow">Units</span>
        <div className="units-card__steppers">
          {this.stepper('Done', rowData.pomodoros, () => this.props.modifyPomodoro(-1,0), () => this.props.modifyPomodoro(1,0))}
          {this.stepper('Estimate', rowData.estimatedPomodoro, () => this.props.modifyPomodoro(0,-1), () => this.props.modifyPomodoro(0,1))}
        </div>
        <ProgressBar task={rowData} size="sm" />
      </div>
    )
  }
}

export default Pomodoro;
